/**
 * Subscription true product IDs that is consistent in Salesforce and Docebo
 * Salesforce product ids are ANs and in Docebo they are Product codes
 * NOTE: BeyondCX, Agent Platform are not supported and will be ignored.
 */
export enum SubscriptionProductIds {
  TECHNICAL_LEARNING_SUBSCRIPTION_AI = '3GP116588ABAA',
  TECHNICAL_LEARNING_SUBSCRIPTION_GENESYS_CLOUD = '3GP110766ABAA',
  TECHNICAL_LEARNING_SUBSCRIPTION_ENGAGE = '3GP113109ACAA',
  TECHNICAL_LEARNING_SUBSCRIPTION_GC_PUREBRIDGE_ATTACH = '3GP116832ABAA',
  TECHNICAL_LEARNING_SUBSCRIPTION_POINTILLIST = '3GP116822ABAA',
  TECHNICAL_LEARNING_SUBSCRIPTION_PURECONNECT = '3GP113114ACAA',
  PARTNER_TECHNICAL_LEARNING_SUBSCRIPTION_ENGAGE = '3GP115052ACAA',
  PARTNER_TECHNICAL_LEARNING_SUBSCRIPTION_PURECONNECT = '3GP115056ACAA',
  PARTNER_GC_PREMIER_LEARNING_SUBSCRIPTION = '3GP115055ABAA',
  //PARTNER_GC_DIGITAL_PLUS_LEARNING_SUBSCRIPTION = '3GP114960ABAA',
  PARTNER_RESELL_GC_TECHNICAL_LEARNING_SUBSCRIPTION = '3GP116258ABAA',
  AGENT_PLATFORM_AP_TRAINING_FOR_GENESYS_CLOUD = '3GP115597ACFA',
  PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION = '3GP116260ACFA',
  PARTNER_GC_DIGITAL_LEARNING_SUBSCRIPTION = '3GP114960ABAA',
  PARTNER_GC_DIGITAL_PLUS_LEARNING_SUBSCRIPTION = '3GP116582ACFA',
}
